
// Nav :: Mobil
// Stänger Personlig meny när man klickar utanför
if ($(window).width() > 1030) {
    $(document).click(function (e) {
        if (!$(e.target).hasClass('inloggad-meny-lank')) {
            $('.inloggad-meny-lank').attr('aria-expanded', 'false').addClass('collapsed');
            $('#inloggad-menydrop').attr('aria-expanded', 'false');
            $('#inloggad-menydrop').removeClass('in');
        }
    });
}

$(document).on('touch', function (e) {
    if (!$(e.target).hasClass('inloggad-meny-lank')) {
        $('.inloggad-meny-lank').attr('aria-expanded', 'false').addClass('collapsed');
        $('#inloggad-menydrop').attr('aria-expanded', 'false');
        $('#inloggad-menydrop').removeClass('in');
    }
});

// Nav :: Mobil
// Länkar i menyn görs klickbara (mobil)
if ($(window).width() < 950) {
    $('#navbar a[href="#"]').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).parent().toggleClass('open');
    });
}

// Nav :: Mobil
// Stänger menyn på knappen underst i menyn (mobil)
$(function () {
    $('.a-nav-open-bg-cover').on('click', function () {
        $('#navbar').removeClass('in');
        $('.navbar-toggle').addClass('collapsed');
        $('.navbar-toggle').removeClass('open');
        if ($('.navbar-toggle').attr('aria-expanded') === 'true') {
            $('.navbar-toggle').attr('aria-expanded', 'false');
        }
    });
});

// Nav :: Mobil
// Lägger till klass i menyn för att expandera och visa var man är (mobil)
if ($(window).width() < 991) {
    $('.navbar-toggle').on('click', function () {
        setTimeout(function () {
            $('.a-dropdown-open').addClass('open');
        });
    });
}

// Nav :: Mobil :: Hambugare till X
$(function () {
    $('.navbar-toggle').click(function () {
        // $(this).toggleClass('open');
        if ($('.navbar-toggle').hasClass('collapsed')) {
            $(this).addClass('open');
        } else {
            $(this).removeClass('open');
        }
    });
    $('.dropdown-mobil-close').click(function () {
        $('.navbar-toggle').removeClass('open');
    });
});

// Länk icke klickbar mobil/tablett (bara på desktop)
if ($(window).width() < 991) {
    $('.graf-klickbar-desktop').each(function () {
        $(this).click(function (e) {
            e.preventDefault();
            e.stopPropagation();
        });
    });
}

// Nav :: Desktop :: Dropmeny
// Lika höjd för länkarna (Fördjupning) i dropmenyn, i desktop-läge. (Nav - drop)
if ($(window).width() < 950) {
    $('.grid').removeClass('resDesk');
} else {
    $('.grid').addClass('resDesk');
}
$(function () {
    setTimeout(function () {
        $('.resDesk').each(function () {
            $(this).children('li').matchHeight({
            });
        });
    }, 1500);
});

// Nav :: Desktop :: Dropmeny :: Mina Sidor
// Lika höjd för länkarna (Fördjupning) i dropmenyn, i desktop-läge. (Nav - drop)
if ($(window).width() < 950) {
    $('.minasidor-wrapper').removeClass('resDeskMinaSidor');
} else {
    $('.minasidor-wrapper').addClass('resDeskMinaSidor');
}
$(function () {
    setTimeout(function () {
        $('.resDeskMinaSidor').each(function () {
            $('.minasidor-lankar').matchHeight();
        });
    }, 1500);
});

// Nav :: Desktop :: Dropmeny
// Lika höjd för länkarna (col-lg-10) i dropmenyn, i desktop-läge. (Nav - drop)
if ($(window).width() < 950) {
    $('.a-nav .col-lg-10 .nav').removeClass('resDesk10');
} else {
    $('.a-nav .col-lg-10 .nav').addClass('resDesk10');
}
$(function () {
    setTimeout(function () {
        $('.resDesk10').each(function () {
            $(this).children('li').matchHeight({
            });
        });
    }, 1500);
});

// ===[ DESKTOP » DROPMENY ] =============================================================
$(function () {
    // $('.navbar-nav .dropdown .dropdown-toggle').attr('aria-expanded', 'false');
    $('.navbar-nav .dropdown .dropdown-toggle').click(function () {
        if ($('.navbar-nav .dropdown .dropdown-toggle').hasClass('in')) {
            // $(this).next('.dropdown-menu').attr('aria-expanded', 'false');
            setTimeout(function () {
                $(this).attr('aria-expanded', 'false');
                $('.inloggad-meny-lank').attr('aria-expanded', 'false');
            }, 50);
        } else {
            // $(this).next('.dropdown-menu').attr('aria-expanded', 'true');
            setTimeout(function () {
                $(this).attr('aria-expanded', 'true');
                $('.inloggad-meny-lank').attr('aria-expanded', 'true');
            }, 50);
        }
    });
});

$(function () {
    $('.navbar-nav .dropdown .dropdown-toggle').click(function () {
        if ($(this).parent().hasClass('open')) {
            $(this).parent().children('.dropdown-menu').attr('aria-expanded', 'false');
        } else {
            $(this).parent().children('.dropdown-menu').attr('aria-expanded', 'true');
        }
    });
});

// Startsidan :: Motorvägar
// Lika höjd för vita fälten under bilderna i motorvägarna, (i desktop-läge).
if ($(window).width() < 991) {
    $('.a-motorvagar').removeClass('resDesk');
} else {
    $('.a-motorvagar').addClass('resDesk');
}
$(function () {
    setTimeout(function () {
        $('.resDesk').each(function () {
            $('.a-motorvag-info').matchHeight();
        });
    }, 1500);
});

// Mina Sidor :: Skydd för efterlevande
// Lika höjd för faktarutor, (i tablet och desktop).
if ($(window).width() < 750) {
    $('.fakta').removeClass('resFakta');
} else {
    $('.fakta').addClass('resFakta');
}
$(function () {
    setTimeout(function () {
        $('.resFakta').each(function () {
            $('ul li').matchHeight();
        });
    }, 1500);
});

// Startsidan :: Motorvägar
// Youtube motorväg Modal
$(function () {
    $('#videoModal').on('show.bs.modal',
        function (event) {
            var button = $(event.relatedTarget);
            var recipient = button.data('thevideo');
            var modal = $(this);
            var iframe = modal.find('iframe');
            iframe.attr('src', recipient);

            if ($(window).width() < 768) {
                var vidWidth = $(window).width() * 0.9;
                iframe.attr('width', vidWidth);
                iframe.attr('height', vidWidth / 1.77777);
            } else if ($(window).width() < 1200) {
                var vidWidth2 = $(window).width() * 0.7;
                iframe.attr('width', vidWidth2);
                iframe.attr('height', vidWidth2 / 1.77777);
            } else {
                var vidWidth3 = $(window).width() * 0.5;
                iframe.attr('width', vidWidth3);
                iframe.attr('height', vidWidth3 / 1.77777);
            }
        });

    $('#videoModal').on('hide.bs.modal', function () {
        var modal = $(this);
        modal.find('iframe').attr('src', '');
    });
});

// FaktaBlock
// Lika höjd för faktablocken om det ligger fler bredvid varrandra. Sweet
if ($(window).width() < 750) {
    $('.faktablock').removeClass('resDeskfaktablock');
} else {
    $('.faktablock').addClass('resDeskfaktablock');
}
$(function () {
    setTimeout(function () {
        $('.resDeskfaktablock').each(function () {
            $('.col-sm-6 .a-faktablock-inner').matchHeight();
            $('.col-sm-4 .a-faktablock-inner').matchHeight();
        });
    }, 1500);
});

// GalleriBlock
// Lika höjd för vita fälten under bilderna, (i desktop-läge).
if ($(window).width() < 750) {
    $('.galleriblock').removeClass('resDeskgalleriblock');
} else {
    $('.galleriblock').addClass('resDeskgalleriblock');
}
$(function () {
    setTimeout(function () {
        $('.resDeskgalleriblock').each(function () {
            $('.galleriblock-text').matchHeight();
        });
    }, 1500);
});

// InfografikBlock
// Lika höjd för text-fält och bild-fält, (i desktop-läge).
if ($(window).width() < 750) {
    $('.infografikblock').removeClass('resDeskinfografikblock');
} else {
    $('.infografikblock').addClass('resDeskinfografikblock');
}
$(function () {
    setTimeout(function () {
        $('.resDeskinfografikblock').each(function () {
            $('.col-sm-6').matchHeight();
        });
    }, 1500);
});

// InfografikBlock
// Lika höjd för text-fält och bild-fält, (i desktop-läge).
if ($(window).width() < 750) {
    $('.a-main section').removeClass('resDeskStornyhet');
} else {
    $('.a-main section').addClass('resDeskStornyhet');
}
$(function () {
    setTimeout(function () {
        $('.resDeskStornyhet').each(function () {
            $('.stornyhetstartsidablock .col-sm-6').matchHeight();
        });
    }, 1500);
});

// Gilla Gilla inte
$(function () {
    $('.ggi-hand-v').click(function () {
        $(this).removeClass('ggi-hand-default');
        $(this).addClass('ggi-hand-active');
        $('.ggi-hand-h').removeClass('ggi-hand-active');
        $('.ggi-hand-h').addClass('ggi-hand-inactive');
        $('.ggi-hjalp').addClass('hidden');
        $('.ggi-tack').removeClass('hidden');
        $('.ggi-steg2').addClass('ggi-steg2-ja');
        $('.ggi-hand-h').off('click');
    });
    $('.ggi-hand-h').click(function () {
        $(this).removeClass('ggi-hand-default');
        $(this).addClass('ggi-hand-active');
        $('.ggi-hand-v').removeClass('ggi-hand-active');
        $('.ggi-hand-v').addClass('ggi-hand-inactive');
        $('.ggi-hjalp').addClass('hidden');
        $('.ggi-tack').removeClass('hidden');
        $('.ggi-steg2').addClass('ggi-steg2-nej');
        $('.ggi-hand-v').off('click');
    });
});

// Listningsblock
// Lika höjd för bilderna, (i desktop-läge).
if ($(window).width() < 991) {
    $('.listningsblock').removeClass('resDeskList');
} else {
    $('.listningsblock').addClass('resDeskList');
}
$(function () {
    setTimeout(function () {
        $('.resDeskList').each(function () {
            $('.listningsblock-text').matchHeight();
        });
    }, 1500);
});

// Tabellblock
// Lika höjd för tabeller 2-i-rad, (tablet +)
if ($(window).width() < 750) {
    $('.tabellblock.col-sm-6').removeClass('resDeskTabellgron2');
} else {
    $('.tabellblock.col-sm-6').addClass('resDeskTabellgron2');
}
$(function () {
    setTimeout(function () {
        $('.resDeskTabellgron2').each(function () {
            $('.tabellblock.col-sm-6 .table-kanter-alecta-gron').matchHeight();
        });
    }, 1500);
});

// Lika höjd för tabeller 3-i-rad, (tablet +)
if ($(window).width() < 750) {
    $('.tabellblock.col-sm-4').removeClass('resDeskTabellgron3');
} else {
    $('.tabellblock.col-sm-4').addClass('resDeskTabellgron3');
}
$(function () {
    setTimeout(function () {
        $('.resDeskTabellgron3').each(function () {
            $('.tabellblock.col-sm-4 .table-kanter-alecta-gron').matchHeight();
        });
    }, 1500);
});

// Tabell
// Räknar kolummer i en tabell och skriver ut det
$(function () {
    if ($(window).width() < 991) {
        $('table').each(function () {
            var rows = $(this).find('tbody > tr:first > td').length;
            $(this).addClass('columns' + rows);
        });
    }
});

// Tabell
// Ifall tabellen är bredare än "fönstret"
$(function () {
    if ($(window).width() < 991) {
        if ($('.tabellblock').closest('.accordion-inner').length > 0) {
            // Tom
        } else {
            $('.tabellblock').each(function () {
                var tableWidth = $(this).find('table').width();
                var divWidth = $(this).width();
                if (divWidth <= tableWidth) {
                    $(this).addClass('table-2-big');
                }
            });
        }
    }
});

// Nyheter startsida
// Lika höjd för nyheter 3-i-rad, tablet+
if ($(window).width() < 750) {
    $('.feeduiblock').removeClass('resDesknyheter');
} else {
    $('.feeduiblock').addClass('resDesknyheter');
}
$(function () {
    setTimeout(function () {
        $('.resDesknyheter').each(function () {
            $('.dynamisktinnehall').matchHeight();
        });
    }, 1500);
});

// PopOver
$(function () {
    $('[data-toggle="popover"]').popover();
});

// PopOver
// Ändra "i" vid klick
$(function () {
    $('[data-toggle="popover"]').click(function () {
        $(this).toggleClass('active');
    });
});

// Nav :: mobil :: Dropmeny
// Lika höjd för länkarna och +
if ($(window).width() < 950) {
    $('.a-nav-side-level .nav-har-barn').addClass('resNavMobil');
} else {
    $('.a-nav-side-level .nav-har-barn').removeClass('resNavMobil');
}
$(function () {
    setTimeout(function () {
        $('.a-nav-side-level .resNavMobil').each(function () {
            $(this).children('a').matchHeight({
            });
        });
    }, 1500);
});

// Mina sidor :: Infoblock
if ($(window).width() > 750) {
    $('.detaljinfo').addClass('resInfoblock');
} else {
    $('.detaljinfo').removeClass('resInfoblock');
}
$(function () {
    setTimeout(function () {
        $('.resInfoblock').each(function () {
            $(this).children('.detaljinfoblock').matchHeight({
            });
        });
    }, 1500);
});

// Mina sidor :: Personliga meddelande
// $(function () {
//    $('.pratbubbla').click(function () {
//        // $('.meddelanden').toggleClass('active', 1000, 'easeOutSine');
//        if ($('.magictime').hasClass('spaceInUp')) {
//            // $('.meddelanden').removeClass('active');
//            $('.magictime').removeClass('spaceInUp');
//            $('.magictime').addClass('spaceOutUp');
//        } else {
//            $('.magictime').addClass('spaceInUp');
//            $('.magictime').removeClass('spaceOutUp');
//        }
//    });
// });

// Kurser
$(function () {
    $('.kurs-formular button').not('.avanmalan').on('click', function (evt) {
        var thisButton = $('.kurs-formular button');
        $('.kurs-registreringsfel').addClass('hidden');

        var form = evt.target.form;
        var validator = $(form).validate();

        var formdata = {};

        for (var i = 0; i < form.elements.length; i++) {
            var element = form.elements[i];
            var kortnamn = element.name.substring(element.name.lastIndexOf('.') + 1);
            formdata[kortnamn] = {
                id: element.id,
                name: element.name,
                value: element.value
            };
        }

        if (validator.valid()) {
            var anmalningsuppgifter = {
                fornamn: formdata.Fornamn.value,
                efternamn: formdata.Efternamn.value,
                foretag: formdata.Foretag.value,
                organisationsnummer: formdata.Organisationsnummer.value,
                mobilnummer: formdata.Mobilnummer.value,
                epost: formdata.Epost.value,
                specialkost: formdata.Specialkost ? $('input[type="radio"][name="' + formdata.Specialkost.name + '"]:checked').val() : false,
                valdSpecialkost: formdata.ValdSpecialkost ? formdata.ValdSpecialkost.value : '',
                valdPaminnelsetyp: formdata.ValdPaminnelsetyp ? formdata.ValdPaminnelsetyp.value : 1
            };

            $('#registrera-aktivitet').click(function () {
                $(this).addClass('knapp-laddar');
            });

            $.ajax({
                type: 'POST',
                url: '/webapi/kurs/' + formdata.ActivityId.value + '/anmalan',
                contentType: 'application/json; charset=utf-8',
                data: JSON.stringify(anmalningsuppgifter),
                dataType: 'json',
                success: function () {
                    var accordionInnerDiv = $(form).closest('.accordion-inner');
                    accordionInnerDiv.find('.kurs-formular').addClass('hidden');

                    var kursTackDiv = accordionInnerDiv.find('.kurs-tack').first();
                    var bekraftelsetextTag = kursTackDiv.find('p').first();
                    var textMedEpost = bekraftelsetextTag.text().replace('{{epost}}', anmalningsuppgifter.epost);
                    bekraftelsetextTag.text(textMedEpost);
                    kursTackDiv.removeClass('hidden');

                    form.reset();
                },
                complete: function () {
                    thisButton.removeClass('knapp-laddar');
                },
                error: function (jqXHR) {
                    var data = JSON.parse(jqXHR.responseText);
                    var errors = {};

                    for (var key in data.ModelState) {
                        if (Object.prototype.hasOwnProperty.call(data.ModelState, key)) {
                            if (key.indexOf('registreringsfel') > -1) {
                                var felmeddelandeDiv = $('#' + key);
                                felmeddelandeDiv.children('p').first().text(data.ModelState[key][0]);
                                felmeddelandeDiv.removeClass('hidden');
                                thisButton.removeClass('knapp-laddar');
                            } else {
                                errors[formdata[key.replace('model.', '')].name] = data.ModelState[key][0];
                            }
                        }
                    }
                    validator.showErrors(errors);
                    validator.focusInvalid();
                }
            });
        } else {
            validator.focusInvalid();
        }
    });
});

$(function () {
    $('.kurs-formular button.avanmalan').on('click', function (evt) {
        var thisButton = $('.kurs-formular button.avanmalan');

        $('.kurs-registreringsfel').addClass('hidden');
        var form = evt.target.form;
        var validator = $(form).validate();

        var formdata = {};

        for (var i = 0; i < form.elements.length; i++) {
            var element = form.elements[i];
            var kortnamn = element.name.substring(element.name.lastIndexOf('.') + 1);
            formdata[kortnamn] = {
                id: element.id,
                name: element.name,
                value: element.value
            };
        }

        if (validator.valid()) {
            $('#registrera-aktivitet').click(function () {
                $(this).addClass('knapp-laddar');
            });

            var avanmalningsuppgifter = {
                fornamn: formdata.Fornamn.value,
                efternamn: formdata.Efternamn.value,
                epost: formdata.Epost.value
            };

            $.ajax({
                type: 'POST',
                url: '/webapi/kurs/' + formdata.ActivityId.value + '/anmalan/delete',
                contentType: 'application/json; charset=utf-8',
                data: JSON.stringify(avanmalningsuppgifter),
                dataType: 'json',
                success: function () {
                    var accordionInnerDiv = $(form).closest('.accordion-inner');
                    accordionInnerDiv.find('.kurs-formular').addClass('hidden');

                    var kursTackDiv = accordionInnerDiv.find('.kurs-tack').first();
                    var bekraftelsetextTag = kursTackDiv.find('p').first();
                    var textMedEpost = bekraftelsetextTag.text().replace('{{epost}}', avanmalningsuppgifter.epost);
                    bekraftelsetextTag.text(textMedEpost);
                    kursTackDiv.removeClass('hidden');

                    form.reset();
                },
                complete: function () {
                    thisButton.removeClass('knapp-laddar');
                },
                error: function (jqXHR) {
                    var data = JSON.parse(jqXHR.responseText);
                    var errors = {
                    };

                    for (var key in data.ModelState) {
                        if (Object.prototype.hasOwnProperty.call(data.ModelState, key)) {
                            if (key.indexOf('avregistreringsfel') > -1) {
                                var felmeddelandeDiv = $('#' + key);
                                felmeddelandeDiv.children('p').first().text(data.ModelState[key][0]);
                                felmeddelandeDiv.removeClass('hidden');
                                thisButton.removeClass('knapp-laddar');
                            } else {
                                errors[formdata[key.replace('model.', '')].name] = data.ModelState[key][0];
                            }
                        }
                    }
                    validator.showErrors(errors);
                    validator.focusInvalid();
                }
            });
        } else {
            validator.focusInvalid();
        }
    });
});
$(function () {
    $('.kurs-btn-anmal').on('click', function () {
        $(this).toggleClass('hidden');
        $(this).parent().siblings('.kurs-avboka').children('[data-toggle="collapse"]').addClass('hidden');
    });
});
$(function () {
    $('.kurs-btn-avboka').on('click', function () {
        $(this).toggleClass('hidden');
        $(this).parent().siblings('.kurs-anmal').children('[data-toggle="collapse"]').addClass('hidden');
        $(this).parent().siblings('.kurs-anmal').children('.kurs-btn-anmal-reserv').addClass('hidden');
    });
});
$(function () {
    $('.kurs-btn-anmal-reservplats').on('click', function () {
        $(this).parent().toggleClass('hidden');
        $(this).parent().parent().siblings('.kurs-avboka').children('[data-toggle="collapse"]').addClass('hidden');
    });
});
$(function () {
    $('.kurs-btn-stang').on('click', function () {
        $(this).parent().parent().siblings('.accordion-toggle').find('.row').find('.kurs-anmal').find('[data-toggle="collapse"]').removeClass('hidden');
        $(this).parent().parent().siblings('.accordion-toggle').find('.row').find('.kurs-anmal').find('.kurs-btn-anmal-reserv').removeClass('hidden');
        $(this).parent().parent().siblings('.accordion-toggle').find('.row').find('.kurs-avboka').find('[data-toggle="collapse"]').removeClass('hidden');
        $(this).closest('.accordion-group').find('.kurs-tack').addClass('hidden');
        $(this).closest('.accordion-group').find('.kurs-formular').removeClass('hidden');
    });
});
$('input[type="radio"][value="true"]').on('ifChecked', function () {
    $('.FormTextbox--Textarea').addClass('textarea-visa');
    if ($(this).valid()) {
        $(this).find('.field-validation-error').addClass('hidden');
    }
});
$('input[type="radio"][value="false"]').on('ifChecked', function () {
    $('.FormTextbox--Textarea').removeClass('textarea-visa');
    if ($(this).valid()) {
        $(this).find('.field-validation-error').addClass('hidden');
    }
});

// Kurser från Carl
$(function () {
    var lastSegment = document.location.href.substr(document.location.href.lastIndexOf('#') + 1);
    $('a[data-kurs-id*="' + lastSegment + '"]').hide();
});

// Personnummersök
$('.personnummersokblock-form input').each(function (index, item) {
    if ($(item).val() !== '') {
        $(item).prev('label').css('opacity', '0');
    }
});

// Personnummersök
// Lägger till mellanrum i nummer (10000 = 10 000)
/* eslint-disable */
$(function () {
    if ($('#Berakningsparametrar_Lon')[0]) {
        var cleaveNumeral = new Cleave('#Berakningsparametrar_Lon', {
            numeral: true,
            numeralThousandsGroupStyle: 'thousand',
            delimiter: ' '
        });
    }
});
/* eslint-enable */

// Sök
// Raderar js-cachen
$(document).ready(function () {
    $('a#sok').click(function () {
        localStorage.setItem('dataresult', '');
    });
});

// Tabb
// Hoppa till innehåll
$(document).ready(function () {
    $('.tabb-hoppa-over').click(function () {
        var skipTo = '#' + this.href.split('#')[1];
        $(skipTo).attr('tabindex', -1).on('blur focusout', function () {
            $(this).removeAttr('tabindex');
        }).focus();
    });
});

// Ta bort tomma element
$('li:empty').remove();

// Lägger till lite marginal ovanför ankarlänken då vi har en "sticky" navigering överst
(function (document) {
    var anchorScrolls = {
        ANCHOR_REGEX: /^#[^ ]+$/,

        /**
         * Establish events, and fix initial scroll position if a hash is provided.
         */
        init: function () {
            this.scrollToCurrent();
            $(window).on('hashchange', $.proxy(this, 'scrollToCurrent'));
            $('body').on('click', 'a', $.proxy(this, 'delegateAnchors'));
        },

        /**
         * Return the offset amount to deduct from the normal scroll position.
         * Modify as appropriate to allow for dynamic calculations
         */
        getMenuOffset: function () {
            return $('nav.navbar .a-top-nav-sticky').height() + 30;
        },

        isCollapsable: function (element) {
            return $(element).hasClass('collapse');
        },

        /**
         * If the provided href is an anchor which resolves to an element on the
         * page, scroll to it.
         * @param  {String} href
         * @return {Boolean} - Was the href an anchor.
         */
        scrollIfAnchor: function (href) {
            if (!this.ANCHOR_REGEX.test(href)) {
                return false;
            }

            var match = document.getElementById(href.slice(1));

            if (match) {
                var scrollTarget;

                if (this.isCollapsable(match)) {
                    $(match).collapse('show');
                    scrollTarget = $(match).parent();
                } else {
                    scrollTarget = $(match);
                }

                var anchorOffset = scrollTarget.offset().top - this.getMenuOffset();
                $('html, body').animate({scrollTop: anchorOffset});
            }

            return Boolean(match);
        },

        /**
         * Attempt to scroll to the current location's hash.
         */
        scrollToCurrent: function (e) {
            if (this.scrollIfAnchor(window.location.hash) && e) {
                e.preventDefault();
            }
        },

        /**
         * If the click event's target was an anchor, fix the scroll position.
         */
        delegateAnchors: function (e) {
            var elem = e.target;

            if (!$(elem).parents('.kursblock') && this.scrollIfAnchor(elem.getAttribute('href'))) {
                e.preventDefault();
            }
        }
    };
    $(document).ready($.proxy(anchorScrolls, 'init'));
})(window.document);

// Guidesidan
// Ändra hash i URL:en
window.changeHash = function (hashvalue) {
    history.replaceState({}, document.title, location.pathname + '#' + hashvalue);
};

// === [ UTBETALNINGSKORT » PRELOADER ] ==================================================
$(function () {
    var utbetalning = '.utbetalningskort.dynamisktinnehall-laddar';
    if ($(utbetalning)[0]) {
        if ($('.utbetalningskort').hasClass('dynamisktinnehall-laddar')) {
            $('.utbetalningskort').append($('<div class="load"><div class="bar"></div></div>'));
        } else {
            $('.utbetalningskort').remove('<div class="load"></div>');
        }
    }
});

window.addEventListener('DOMContentLoaded', () => {
    (function () {
        const button = document.querySelector('[data-fn-toggle-quickmenu]');

        if (button === null || button.length === 0) {
            return;
        }

        const quickMenu = document.querySelector('[data-fn-quickmenu]');
        const menuPanel = document.querySelector('[data-fn-quickmenu-panel]');

        const addClass = (element, className) => {
            element.classList.add(className);
        };
        const removeClass = (element, className) => {
            element.classList.remove(className);
        };

        function transition(elem, styleProps) {
            return new Promise(resolve => {
                function handleTransitionEnd() {
                    resolve(elem);
                }
                elem.addEventListener('transitionend', handleTransitionEnd, {once: true});

                Object.entries(styleProps).forEach(([prop, value]) => {
                    elem.style.setProperty(prop, value);
                });
            });
        }

        const closeMenu = async (btn, menu) => {
            removeClass(button, 'open');

            await transition(menu, {
                transform: 'translateY(-115%)'
            });
            await transition(btn, {
                width: '217px'
            }).then(() => removeClass(quickMenu, 'active'));
        };

        const openMenu = async (btn, menu) => {
            addClass(quickMenu, 'active');
            addClass(button, 'open');
            await transition(btn, {
                width: '600px'
            });
            await transition(menu, {
                transform: 'translateY(0)'
            });
        };

        async function openQuickMenu(btn, menu) {
            if (button.classList.contains('open')) {
                await closeMenu(btn, menu);
            } else {
                await openMenu(btn, menu);
            }
            button.removeAttribute('disabled');
        }

        button.addEventListener('click', () => {
            button.setAttribute('disabled', true);
            openQuickMenu(button, menuPanel);
        });

        document.body.addEventListener('click', event => {
            if (button.classList.contains('open')) {
                if (!event.target.matches('.nav-snabbmeny, .nav-snabbmeny *')) {
                    closeMenu(button, menuPanel);
                    button.removeAttribute('disabled');
                    button.focus();
                }
            }
        });
    })();
});

